import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CsvUploadService } from "../../../services/csv-upload.service";
import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-airport-master",
  templateUrl: "./airport-master.component.html"
})
export class AirportMasterComponent implements OnInit {
  disablestatus = false;
  offSubmit = false;
  minRemark = false;
  data_present = false;
  rejected = 0;
  airportCodeExceedLength1 = false;
  airportCodeMinLength1 = false;
  airportCodeNotAlphabets1 = false;
  onlyspaces1 = false;
  auto_msg = "";
  nameExist1 = false;
  autoArray: any = [];
  previousData: any = [];
  formstatusdata = [];
  cityCodes: any = [];
  onlyspaces = false;
  isApproved = false;
  hide = false;
  gotoChangeStatus = true;
  approveStatus;
  aprvbtn = false;
  updateApprove = false;
  forupdate = false;
  STAT = 1;

  searchresult = false;
  loader: any = false;
  onlyspclchar = false;
  showApprove = false;
  viewPageDetails = [];
  viewpage = false;
  dblclick = false;
  nameExist = false;

  airportCodeMinLength = false;
  airportCodeExceedLength = false;
  airportCodeNotAlphabets: boolean = false;

  airportNameMinLength = false;
  airportNameExceedLength = false;
  airportNameNotAlphabet: boolean = false;

  searchlist: boolean = true;
  showList: boolean = false;
  screentitle: string = "Airport Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_airport";
  parent_table_ID = "AIRPORT_ID";
  AIRPORT_CODE = "AIRPORT_CODE";
  AIRPORT_NAME = "AIRPORT_NAME";
  CITY_NAME = "CITY_NAME";
  CITY_CODE = "CITY_CODE";
  COUNTRY_CODE = "COUNTRY_CODE";
  COUNTRY_NAME = "COUNTRY_NAME";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  Parent_result_ID = "";
  dbFields = [
    this.AIRPORT_CODE,
    this.AIRPORT_NAME,
    this.CITY_CODE,
    this.APPROVAL_STATUS,
    "STATUS"
  ];
  
  dbField = [this.AIRPORT_CODE, this.AIRPORT_NAME, this.CITY_CODE];
  searchitem = " ";
  searchColumn = " ";
  childtables = [];
  filters = [];
  screen_details: any = [];
  search_details: any = [];
  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;
  csvRecords = [];
  fileImportInput: any;

  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  constructor(
    private vernostService: VernostServiceService,
    private csvupload: CsvUploadService,
    private logService: Loggerservice,
    private commonService : CommonService,
    private router: Router
  ) { }

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    // alert("fid"+this.fid);
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArrayAirportMaster = {
      funId: this.fid,
      roleID: this.roleID
    };

    this.vernostService.checkFunAccess(rollArrayAirportMaster).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      AIRPORT_CODE: "",
      AIRPORT_NAME: "",
      CITY_CODE: "",
      CITY_NAME: "",
      COUNTRY_CODE: "",
      COUNTRY_NAME: ""
    };
    this.search_details = {
      AIRPORT_CODE: "",
      AIRPORT_NAME: "",
      CITY_CODE: "",
      CITY_NAME: "",
      COUNTRY_CODE: "",
      COUNTRY_NAME: ""
    };
    this.showList = false;
  }

  checkAproval() {
    // this.aprovebtn="";

    var dbField = [this.APPROVAL_STATUS];
    let arrayAirportMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayAirportMaster).subscribe(res => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(res[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  changeName() {
    // alert(this.Parent_result_ID);
    var data = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "AIRPORT_ID"
    };

    this.vernostService.getSTATUS(data).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData();

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var dataAirportMaster = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "AIRPORT_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataAirportMaster).subscribe(response => {
      this.searchData();
    });
  }*/

  gotochangestatus() {
    let data = this.commonService.gotochangestatus(this.actionmode,[this.parent_table,this.Parent_result_ID, this.parent_table_ID]);
    this.vernostService.editstatus(data).subscribe(res => {
      this.isApproved = false
    });
  }

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'airport-master');
  }

  aproveReject(status) {
    if (!this.nameExist1) {
      this.isApproved = true;
      var currentTime = new Date();

      var dbFieldAirportMaster = [
        this.APPROVAL_STATUS,
        this.APPROVAL_REMARKS,
        this.APPROVAL_BY,
        "STATUS",
        "APPROVAL_DATE_TIME"
      ];
      if (status == 1) {
        this.approveStatus = 1;
      }
      var formDataAirportMaster = [
        status,
        this.aprove_details.APPROVAL_REMARKS,
        this.uid,
        status,
        currentTime
      ];
      var array = {
        dbField: dbFieldAirportMaster,
        parent_table: this.parent_table,
        formData: formDataAirportMaster,
        parent_table_ID: this.parent_table_ID,
        formdataId: this.Parent_result_ID
      };

      this.vernostService.aproveReject(array).subscribe(resp => {
        this.aprove_details.APPROVAL_REMARKS = "";
        if (status == 2) {
          this.rejected = 2;

          this.logService.create_log_masters(
            "'Component Name':Airport Master,'Action':Reject Record,'Modified by':" +
            localStorage.getItem("fname") +
            "'Record':" +
            JSON.stringify(this.screen_details),
            "info"
          );
        } else {
          if (this.isApproved && this.actionmode == "Edit") {
            this.checkColor();
          }

          if (resp[0].aproval == "aproved") {
            this.aprvbtn = false;
            this.logService.create_log_masters(
              "'Component Name':City Master,'Action':Approve Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Record':" +
              JSON.stringify(this.screen_details),
              "info"
            );
          }
          this.aprvbtn = false;
        }
      });
      if (this.actionmode == "Edit") {
        this.submitData1();
      }
      this.searchData();
    }
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

  /*
  count1 = 0;
  count2 = 0;
  sortByOrder_AM(data, number) {
    if (number == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
    }
    if (number == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
    }
    var arrayAirportMaster = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayAirportMaster).subscribe(response => {
      this.serachtabledata = response;
    });
  } */

  addForm() {
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.nameExist1 = false;
    this.airportCodeMinLength = false;
    this.airportCodeExceedLength = false;
    this.airportCodeNotAlphabets = false;
    this.airportNameMinLength = false;
    this.airportNameExceedLength = false;
    this.airportNameNotAlphabet = false;
    this.Parent_result_ID = "";
    this.showList = false;
    this.actionmode = "Add";
    this.forupdate = false;
    document.getElementById("errs").innerHTML = "";
  }
  openfileDialog() {
    document.getElementById("fileLoader").click();
  }
  searchForm() {
    if (this.actionmode != "Edit") {
      this.searchData();
    } else {
      this.search_details.AIRPORT_CODE = "";
      this.search_details.AIRPORT_NAME = "";
      this.searchresult = false;
    }
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.nameExist1 = false;
    this.airportCodeExceedLength1 = false;
    this.airportCodeNotAlphabets1 = false;
    this.updateApprove = false;
    this.airportCodeMinLength = false;
    this.airportCodeExceedLength = false;
    this.airportCodeNotAlphabets = false;
    this.airportNameMinLength = false;
    this.airportNameExceedLength = false;
    this.airportNameNotAlphabet = false;
    this.screen_details = {
      AIRPORT_CODE: "",
      AIRPORT_NAME: "",
      CITY_CODE: "",
      COUNTRY_CODE: "",
      COUNTRY_NAME: "",
      CITY_NAME: ""
    };

    this.actionmode = "Search";
    this.viewpage = false;
    this.showList = false;
    this.showApprove = false;
    this.hide = false;
    this.disablestatus = false;
  }
  showFormData(formData, toggle, status, approvestatus) {
    this.screen_details.CITY_CODE="tets"
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }

    this.Parent_result_ID = formData;
    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(array).subscribe(response => {
      this.screen_details = {
        AIRPORT_CODE: response[0].result[0].AIRPORT_CODE,
        AIRPORT_NAME: response[0].result[0].AIRPORT_NAME,
        CITY_CODE: response[0].result[0].CITY_CODE
      };
      this.cityCodes = [{
        "value": this.screen_details.CITY_CODE, 
        "label": this.screen_details.CITY_CODE
     }];
      this.approveStatus = response[0].result[0].STATUS;
      this.viewPageDetails = response[0].result;
      this.previousData = response[0].result;

      if (toggle == "1") {
        this.actionmode = "Add";
        this.viewpage = true;
        if (!this.showApprove) {
          this.showList = true;
        } else {
          this.showList = false;
        }
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitData1() {
    if (
      this.screen_details.AIRPORT_CODE == "" ||
      this.screen_details.AIRPORT_CODE == undefined ||
      this.screen_details.AIRPORT_NAME == "" ||
      this.screen_details.AIRPORT_NAME == undefined ||
      !this.screen_details.CITY_CODE || this.screen_details.CITY_CODE == ""
    ) {
      document.getElementById("errs").innerHTML = "Please fill all record";
    } else {
      this.loader = true;
      this.offSubmit = true;
      if (this.actionmode != "Edit") {
        this.checkNames();
      } else {
        this.onEdit_checkName();
      }
    }
  }

  onEdit_checkName() {
    if (this.actionmode == "Edit") {
      var code = this.screen_details.AIRPORT_CODE;
      var name = this.screen_details.AIRPORT_NAME;
      var table = this.parent_table;

      var column = "AIRPORT_NAME";
      var column1 = "AIRPORT_CODE";
      let array = {
        code: code,
        name: name,
        table: table,
        column: column,
        column1: column1
      };

      this.vernostService.checkRecordName(array).subscribe(data => {
        if (data[0].status == "success") {
          this.data_present = true;
          this.loader = false;
          this.nameExist1 = true;
        } else {
          this.data_present = false;

          if (this.offSubmit) {
            this.submitdata();
          }
        }
      });
    }
  }

  submitdata() {
    this.offSubmit = false;
    this.updateApprove = false;
    this.hide = false;
    this.disablestatus = false;

    this.dblclick = true;

    if (
      this.screen_details.AIRPORT_CODE == "" ||
      this.screen_details.AIRPORT_NAME == "" ||
      this.screen_details.CITY_CODE == ""
    ) {
      // alert("Please fill all the Field");
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      var acode = this.screen_details.AIRPORT_CODE.toUpperCase();
      let cityCode = this.screen_details.CITY_CODE;
      let aname = this.screen_details.AIRPORT_NAME;
      let cityName = "";
      let countryName = "";
      let countryCode = "";
      var formData = [acode, this.screen_details.AIRPORT_NAME, this.screen_details.CITY_CODE];

      let request = {
        inputSearchString: this.screen_details.CITY_CODE,
        parentTableName: "mst_city",
        like: "CITY_CODE"
      };

      this.vernostService.getCityData(request).subscribe(response => {
        cityName = response[0].CITY_NAME;
        countryCode = response[0].COUNTRY_CODE;
        countryName = response[0].COUNTRY_NAME;

        let airportJSON = {
          "AIRLINE_NAME": aname,
          "AIRLINE_CODE": acode,
          "CITY_NAME": cityName,
          "CITY_CODE": cityCode,
          "COUNTRY_CODE": countryCode,
          "COUNTRY_NAME": countryName
        };
  
        if (this.Parent_result_ID != "") {
          var array = {
            parent_table: this.parent_table,
            dbFields: this.dbField,
            parent_table_ID: this.parent_table_ID,
            formData: formData,
            formdataId: this.Parent_result_ID,
            USER_ID: this.uid,
            airportJSON: airportJSON
          };
          this.vernostService.editData(array).subscribe(editResponse => {
            document.getElementById("errs").innerHTML = "Record updated Successfully";
            this.dblclick = false;
            this.forupdate = true;
            this.loader = false;
            this.logService.create_log_masters(
              "'Component Name':Airport Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(this.screen_details),
              "info"
            );
          });
        }
        if (this.Parent_result_ID == "") {
          var Data = {
            parent_table: this.parent_table,
            dbFields: this.dbField,
            formData: formData,
            USER_ID: this.uid,
            PAGENAME: "AIRPORT",
            airportJSON: airportJSON
          };
  
          this.vernostService.insertData(Data).subscribe(insertResponse => {
            document.getElementById("errs").innerHTML = "Record Created Successfully";
            this.loader = false;
            this.dblclick = false;
            this.viewpage = true;
            this.showList = false;
            this.showApprove = true;
  
            this.showFormData(insertResponse[0].addinfo, 1, 1, 1);
            this.logService.create_log_masters(
              "'Component Name':Airport Master,'Action':Create Record,'Modified by':" +
              localStorage.getItem("fname") +
              ",'Record':" +
              JSON.stringify(this.screen_details),
              "info"
            );
          });
        }
      });
    }
  }
  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.AIRPORT_CODE;
    var field2 = this.search_details.AIRPORT_NAME;
    if (
      (field1 == "" || field1 == undefined) &&
      (field2 == "" || field2 == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML = "Please select some criteria";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(field1);
        searchColumn.push("AIRPORT_CODE");
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(field2);
        searchColumn.push("AIRPORT_NAME");
      }

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data));
      this.vernostService.searchRecord(Data).subscribe(response => {
        this.loader = false;
        //this.serachtabledata = response;
        if (response.length > 0) {
          this.searchresult = true;
          this.serachtabledata = response;
          document.getElementById("errs").innerHTML = "";

          this.logService.create_log_masters(
            "'Component Name':Airport Master,'Action':Srarch Record,'Modified by':" +
            localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }
      });
    } //   this.loadData();
  }

  fileChangeListener($event): void {
    this.csvupload.fileChangeListen($event, this.parent_table);
  }

  checkAirportCode(data, flag) {
    this.validateAirportCode(data);
    if (flag == 1) {
      this.checkNames();
    }
  }
  validateAirportCode(data) {
    if (data.length == 0) {
      this.airportCodeNotAlphabets = false;
      this.airportCodeMinLength = false;
    } else {
      if (data.length == "") {
        this.airportCodeNotAlphabets = false;
      }
      if (data.length < 3) {
        this.airportCodeMinLength = true;
        // this.airportCodeNotAlphabets = false;
      } else {
        this.airportCodeMinLength = false;
      }
    }
  }
  checkAirportCode1(data) {
    if (data.length == 0) {
      this.airportCodeNotAlphabets1 = false;
      this.airportCodeMinLength1 = false;
    } else {
      if (data.length == "") {
        this.airportCodeNotAlphabets1 = false;
      }
      if (data.length < 3) {
        this.airportCodeMinLength1 = true;
        // this.airportCodeNotAlphabets = false;
      } else {
        this.airportCodeMinLength1 = false;
      }
    }
  }

  checkAirportCodeLength1(data) {
    this.airportCodeExceedLength1 = false;
    this.airportCodeMinLength1 = false;
    this.airportCodeNotAlphabets1 = false;
    this.onlyspaces1 = false;

    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.airportCodeExceedLength1 = false;
      this.airportCodeMinLength1 = false;
      this.airportCodeNotAlphabets1 = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      if (data.length > 3) {
        this.airportCodeExceedLength1 = true;
        this.airportCodeMinLength1 = false;
      } else {
        this.airportCodeExceedLength1 = false;
      }
      if (!checkAlphabet) {
        this.airportCodeNotAlphabets1 = true;
      } else {
        this.airportCodeNotAlphabets1 = false;
      }
    }
  }

  checkAirportCodeLength(data) {
    this.nameExist = false;

    this.airportCodeExceedLength = false;
    this.airportCodeMinLength = false;
    this.airportCodeNotAlphabets = false;
    this.onlyspaces = false;

    // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
    var regx = /^[A-Za-z]+$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.airportCodeExceedLength = false;
      this.airportCodeMinLength = false;
      this.airportCodeNotAlphabets = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      if (data.length > 3) {
        this.airportCodeExceedLength = true;
        this.airportCodeMinLength = false;
      } else {
        this.airportCodeExceedLength = false;
      }
      if (!checkAlphabet) {
        this.airportCodeNotAlphabets = true;
      } else {
        this.airportCodeNotAlphabets = false;
      }
    }
  }

  checkAirportName(data) {
    this.onEdit_checkName();

    this.validateAirportNames(data);

    var regsx = /^[',-]+$/;
    var onlyspecialchar = regsx.test(data);
    if (data.length == 0) {
      this.onlyspclchar = false;
      this.onlyspaces = false;
    } else {
      var space_reg = /^[ ]+$/;
      var onlyspace = space_reg.test(data);
      if (onlyspace) {
        this.onlyspaces = true;
      }

      if (onlyspecialchar) {
        this.onlyspclchar = true;
      } else {
        this.onlyspclchar = false;
      }
    }
  }
  validateAirportNames(data) {
    if (data.length == 0) {
      this.airportNameNotAlphabet = false;
      this.airportNameMinLength = false;
    } else {
      if (data.length == "") {
        this.airportNameNotAlphabet = false;
      }
      if (data.length < 3) {
        this.airportNameMinLength = true;
        // this.airportNameNotAlphabet = false;
      } else {
        this.airportNameMinLength = false;
      }
    }
  }
  checkAirportNameLength(data) {
    this.nameExist1 = false;
    this.data_present = false;
    document.getElementById("errs").innerHTML = "";
    this.airportNameExceedLength = false;
    this.airportNameMinLength = false;
    this.airportNameNotAlphabet = false;

    var regx = /^[^-\s][a-zA-Z',-\s]{0,128}$/;
    // var regx = /^[^-\s][a-zA-Z0-9"!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"\s]{0,100}$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.airportNameExceedLength = false;
      this.airportNameMinLength = false;
      this.onlyspaces = false;
      this.airportNameNotAlphabet = false;
    } else {
      this.onlyspaces = false;
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      if (data.length > 128) {
        this.airportNameExceedLength = true;
        this.airportNameMinLength = false;
      } else {
        this.airportNameExceedLength = false;
      }
      if (!checkAlphabet) {
        this.airportNameNotAlphabet = true;
      } else {
        this.airportNameNotAlphabet = false;
      }
    }
  }

  checkNames() {
    if (
      this.screen_details.AIRPORT_CODE != "" &&
      this.screen_details.AIRPORT_CODE != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "AIRPORT_CODE",
          dbFieldName: this.screen_details.AIRPORT_CODE.toUpperCase(),
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.checkNames1();
            }
          } else {
            this.nameExist = true;
            this.loader = false;
          }
        });
      }
    }
  }

  checkNames1() {
    if (
      this.screen_details.AIRPORT_NAME != "" &&
      this.screen_details.AIRPORT_NAME != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "AIRPORT_NAME",
          dbFieldName: this.screen_details.AIRPORT_NAME,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist1 = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist1 = true;
            this.loader = false;
          }
        });
      }
    }
  }

  autoCompleteSearch(event, columnName) {

    columnName = columnName || "AIRPORT_NAME";

    var data = {
      inputSearchString: columnName == "AIRPORT_NAME" ? event : event.toUpperCase(),
      parentTableName: columnName == "AIRPORT_NAME" ? "mst_airport" : "mst_city",
      searchDBColumnName: columnName == "AIRPORT_NAME" ? ["AIRPORT_NAME", "AIRPORT_CODE"] : ["CITY_NAME", "CITY_CODE"],
      like: columnName == "AIRPORT_NAME" ? "AIRPORT_NAME" : "CITY_CODE"
    };
    if (event.length < 3) {
      this.auto_msg = "";
    }
    if (event.length >= 3) {
      this.vernostService.getRecords(data).subscribe(response => {
        this.formstatusdata = [];
        this.autoArray = response;

        let value = new Array();
        for (let i = 0; i < this.autoArray.length; i++) {
          value[i] = {
            value: columnName == "AIRPORT_NAME" ? this.autoArray[i].AIRPORT_NAME : this.autoArray[i].CITY_CODE,
            label: columnName == "AIRPORT_NAME" ? this.autoArray[i].AIRPORT_NAME : this.autoArray[i].CITY_CODE
          };
          this.formstatusdata =  columnName == "AIRPORT_NAME" ? value.slice(0) : this.formstatusdata;
          this.cityCodes =  columnName == "AIRPORT_NAME" ? this.cityCodes : value.slice(0);
          console.log(this.cityCodes);
        }
      });
    } else {
      this.formstatusdata = columnName == "AIRPORT_NAME" ? [] : this.formstatusdata;
      this.cityCodes = columnName == "AIRPORT_NAME" ? this.cityCodes : [];
    }
  }





  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }

  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }
}
